import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
  name: 'cpBoldText'
})
export class BoldTextPipe implements PipeTransform {
  transform(originStr: string, boldRegex: string ): string {
    const regex = new RegExp(boldRegex, 'gi');
    return originStr.replace(regex,
      (match) => `<strong>${match.replace(/\*/g,'')}</strong>`);

  }
}
